import { render, staticRenderFns } from "./Details1688.vue?vue&type=template&id=73cd3048&scoped=true&"
import script from "./Details1688.vue?vue&type=script&lang=js&"
export * from "./Details1688.vue?vue&type=script&lang=js&"
import style0 from "./Details1688.vue?vue&type=style&index=0&id=73cd3048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd3048",
  null
  
)

export default component.exports